$('.js-faq-open').on('click', function (event) {
  $(this).toggleClass('is_open');
  $(this).closest('li').find('.js-faq-body').slideToggle();
});
